import { z } from 'zod';

export const getImpactAnswersDtoSchema_Digital = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    dataUsage: z.string(),
    videoViews: z.string(),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    score: z.number().optional(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionDigitalDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  dataUsage: string | number; // received in string but sent in number
  videoViews: string | number; // received in string but sent in number
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  score?: number;
  tags?: { values?: Array<{ id: number; name: string }> };
};
